import UpdateFileUpload from './UpdateFileUpload'

export default UpdateFileUpload